import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 68 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      width={68}
      height={52}
      fill="white"
    />
    <rect
      x={19.5}
      y={6.5}
      width={29}
      height={39}
      rx={1.5}
      stroke="#29292F"
    />
    <rect
      x={23.5}
      y={10.5}
      width={21}
      height={27}
      rx={0.5}
      fill="#FFE6ED"
      stroke="#FFD5E1"
    />
    <circle
      cx={34}
      cy={42}
      r={0.5}
      stroke="#29292F"
    />
  </svg>
);
const SvgTabletDevice = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgTabletDevice;
